import { render, staticRenderFns } from "./ShopMoneyRecord.vue?vue&type=template&id=f2c66e4a&scoped=true"
import script from "./ShopMoneyRecord.vue?vue&type=script&lang=js"
export * from "./ShopMoneyRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopMoneyRecord.vue?vue&type=style&index=0&id=f2c66e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c66e4a",
  null
  
)

export default component.exports